import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_milestone_table = _resolveComponent("milestone-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, {
      label: "Function",
      classes: "mx-auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_button, {
          name: "Event Detail",
          icon: "fa-eye",
          theme: "info",
          to: { name: _ctx.ROUTE_NAME_LIVEOPS.ITEM.DETAIL(_ctx.itemInfo.rewardType), params: { id: _ctx.itemInfo.id } }
        }, null, 8, ["to"]),
        _createVNode(_component_app_button, {
          name: "Add milestone",
          icon: "fa-plus",
          theme: "info",
          to: { name: _ctx.ROUTE_NAME_LIVEOPS.MILESTONE.ADD, params: { itemId: _ctx.itemInfo.id } },
          disabled: !_ctx.itemInfo.canEditMilestone
        }, null, 8, ["to", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_milestone_table, {
          rows: _ctx.list,
          total: _ctx.total,
          "can-edit": _ctx.itemInfo.canEditMilestone,
          "on-remove": _ctx.actions.remove,
          "on-refresh": _ctx.fetchList
        }, null, 8, ["rows", "total", "can-edit", "on-remove", "on-refresh"])
      ]),
      _: 1
    })
  ], 64))
}